import React from 'react';
import { Info } from '@material-ui/icons';
import { SecondaryButton } from '../../components/AtomComponents';

interface IHeaderProps {
  meta: {
    environment: string;
    release: string;
    tenantId?: string;
  };
  reviewQueries?: () => void;
  reviewData: {
    queryData: any[] | null;
    currentTotalApprovers?: number;
    currentlyApprovedBy?: string[];
    newQueriesCount?: number;
  };
}

const QueryReviewHeader = ({ meta, reviewQueries, reviewData }: IHeaderProps) => {
  const { environment, release, tenantId } = meta;
  const { queryData, newQueriesCount, currentTotalApprovers, currentlyApprovedBy } = reviewData;

  return (
    <div className="px-query-review-dialog-header">
      <div className="header-top">
        <span className="dialog-title">Review Queries and Approve</span>
        <div className="header-actions">
          <span className="right-click-badge">
            <Info className="badge-icon" />
            <span>Right click table to copy or export queries</span>
          </span>
          {reviewQueries && (
            <SecondaryButton onClick={reviewQueries} size="small" className="refresh-btn">
              Refresh
            </SecondaryButton>
          )}
        </div>
      </div>
      <div className="dialog-meta-row">
        <span className="meta-item">Environment: <strong>{environment ? environment.toUpperCase() : '--'}</strong></span>
        <span className="meta-item">Release: <strong>{release ? release.toUpperCase() : '--'}</strong></span>
        <span className="meta-item">Total Queries: <strong>{queryData !== null ? queryData.length : 0}</strong></span>
        <span className="meta-item px-new-queries-legend">
          <span className="px-legend-color" />
          <span>New Queries Count: <strong>{newQueriesCount ?? 0}</strong></span>
        </span>
        <span className="meta-item">Total Approvers Count: <strong>{currentTotalApprovers ?? 0}</strong></span>
        <span className="meta-item">Total Approvers: <strong>{currentlyApprovedBy?.length ? currentlyApprovedBy.join(', ') : '--'}</strong></span>
      </div>
    </div>
  );
};

export default QueryReviewHeader;
